import { Controller } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Combobox } from '@/components/ui/combobox';
import { FormError } from '@/components/ui/form-error';
import { useDeviceCreateForm } from '@/hooks/production/use-device-create-form';

export function DeviceCreateForm() {
  const { formError, clearFormError, form, handleSubmit, isSubmitting, products } =
    useDeviceCreateForm();
  const {
    register,
    control,
    formState: { errors },
  } = form;

  return (
    <form noValidate onSubmitCapture={clearFormError} onSubmit={handleSubmit}>
      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-4">
              <label htmlFor="serial" className="block text-sm font-medium leading-6 text-gray-900">
                Serial
              </label>
              <div className="mt-2">
                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-600 sm:max-w-md">
                  <span className="flex select-none items-center pl-3 text-gray-500 sm:text-sm">
                    serial:
                  </span>
                  <input
                    {...register('equipment.serial')}
                    type="text"
                    id="serial"
                    autoComplete="serial"
                    className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    placeholder="22554156"
                  />
                </div>
                {errors.equipment?.serial && (
                  <p className="mt-1 text-sm text-red-500">{errors.equipment.serial.message}</p>
                )}
              </div>
            </div>

            <div className="sm:col-span-4">
              <label
                htmlFor="product_id"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Modelo
              </label>
              <div className="mt-2">
                <Controller
                  control={control}
                  name="product_id"
                  render={({ field }) => {
                    const selectedProduct = field.value
                      ? products.find((p) => p.id === field.value)
                      : undefined;

                    return (
                      <Combobox
                        data={products}
                        keyExtractor={(product) => product.id}
                        displayValueGetter={(product) => product.name}
                        type="single"
                        value={selectedProduct ? [selectedProduct] : []}
                        onOptionChange={(selected) => {
                          field.onChange(selected[0]?.id || '');
                        }}
                        placeholder="Selecione o modelo"
                        className="sm:max-w-md"
                      />
                    );
                  }}
                />
                {errors.product_id && (
                  <p className="mt-1 text-sm text-red-500">{errors.product_id.message}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormError error={formError} onDismiss={clearFormError} />
      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">
          Cancelar
        </button>
        <Button
          type="submit"
          disabled={isSubmitting}
          className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
        >
          Salvar
        </Button>
      </div>
    </form>
  );
}
